import React, { useCallback } from 'react'
import { hooks, I18n } from '@front/volcanion'

import { Box, Typography } from '@mui/material'
import { ExpandPanelComponent, ExpandPanelContent, ExpandPanelTitle, TableHeader, TableRow, TableRowActions, FormTable } from '@front/squirtle'


import Header from './Header'
import Row from './Row'
import ButtonRowActions from './ButtonRow'

const CustomHeader = props => {
  const count = hooks.useSearchListenerCount('order', 'order_validation_list')

  return (
    <Box sx={{ p: 2 }}>
      <Typography color={'primary'} variant='h5' textAlign={'center'} letterSpacing={1.5}>
        {I18n.t('billing.list', { count })}
      </Typography>
    </Box>
  )
}

const BillingList = ({ handleBillingAction }) => {
  const [openSearchList, setOpenSearchList] = hooks.useGlobalState('open_search_list')
  const [, setSelectedRow] = hooks.useGlobalState('selected_validation_order')
  const [, setOpenSearchForm] = hooks.useGlobalState('open_search_form')


  const onRowClick = useCallback(rowId => {
    if (!rowId) return
    setSelectedRow(rowId)
    setOpenSearchForm(false)
    setOpenSearchList(false)
  }, [setSelectedRow, setOpenSearchList, setOpenSearchForm])


  return (
    <ExpandPanelComponent
      open={openSearchList}
      toggleOpen={setOpenSearchList}
      TransitionProps={{
        timeout: {
          appear: 2000,
          enter: 2000,
          exit: 200
        }
      }}>
      <ExpandPanelTitle><CustomHeader /></ExpandPanelTitle>
      <ExpandPanelContent>
        <FormTable
          name="order_validation_list_table"
          model_name="order"
          config={{
            listener_type: 'attached',
            search_id: 'order_validation_list',
            populate: ['events']
          }}
          tableProps={{
            selectRowStateID: 'selected_validation_order',
            onRowClick,
            enableRowActions: true,
            enableGlobalActions: false,
            enableToolbar: false,
            enablePagination: true,
            placementPagination: 'bottom',
            allowEditMode: false,
            allowRowGenerate: false,
            disableCancelRowLabel: false,
            disableSaveRowLabel: false,
            containerProps: {
              sx: { height: 'max-content' }
            },
            stickyHeader: true
          }}
        >
          <TableHeader><Header /></TableHeader>
          <TableRow><Row /></TableRow>
          <TableRowActions><ButtonRowActions handleBillingAction={handleBillingAction} /></TableRowActions>
        </FormTable>
      </ExpandPanelContent>
    </ExpandPanelComponent >
  )
}

export default BillingList
